import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'banner-confirmed-flight-afected',
    templateUrl: './banner-confirmed-flight-afected.component.html',
    styleUrls: ['./banner-confirmed-flight-afected.component.scss'],
    standalone: false
})
export class BannerConfirmedFlightAfectedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
